/**
 * Arborsense API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 12.2.8 (4a3936f)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ProcessedSequenceItems } from '../model/processedSequenceItems';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


export interface ProcessedSequenceItemsDeleteRequestParams {
    id?: string;
    sequenceId?: string;
    rawSequenceItemId?: string;
    activityAt?: string;
    smoothedVoltage?: string;
    smoothedTemp1?: string;
    smoothedTemp2?: string;
    smoothedHumidity1?: string;
    smoothedHumidity2?: string;
    ambientSensor1?: string;
    ambientSensor2?: string;
    irSensor1?: string;
    irSensor2?: string;
    slope1?: string;
    slope2?: string;
    finalGrapheneSensorData?: string;
    baselineGrapheneSensorData?: string;
    smoothedGrapheneSensorData?: string;
    tacValue?: string;
    setToZeroThreshold?: string;
    finalSuppressedData?: string;
    isTamper?: string;
    batteryLevel?: string;
    timeInterval?: string;
    createdAt?: string;
    updatedAt?: string;
    /** Preference */
    prefer?: 'return=representation' | 'return=minimal' | 'return=none';
}

export interface ProcessedSequenceItemsGetRequestParams {
    id?: string;
    sequenceId?: string;
    rawSequenceItemId?: string;
    activityAt?: string;
    smoothedVoltage?: string;
    smoothedTemp1?: string;
    smoothedTemp2?: string;
    smoothedHumidity1?: string;
    smoothedHumidity2?: string;
    ambientSensor1?: string;
    ambientSensor2?: string;
    irSensor1?: string;
    irSensor2?: string;
    slope1?: string;
    slope2?: string;
    finalGrapheneSensorData?: string;
    baselineGrapheneSensorData?: string;
    smoothedGrapheneSensorData?: string;
    tacValue?: string;
    setToZeroThreshold?: string;
    finalSuppressedData?: string;
    isTamper?: string;
    batteryLevel?: string;
    timeInterval?: string;
    createdAt?: string;
    updatedAt?: string;
    /** Filtering Columns */
    select?: string;
    /** Ordering */
    order?: string;
    /** Limiting and Pagination */
    range?: string;
    /** Limiting and Pagination */
    rangeUnit?: string;
    /** Limiting and Pagination */
    offset?: string;
    /** Limiting and Pagination */
    limit?: string;
    /** Preference */
    prefer?: 'count=none';
}

export interface ProcessedSequenceItemsPatchRequestParams {
    id?: string;
    sequenceId?: string;
    rawSequenceItemId?: string;
    activityAt?: string;
    smoothedVoltage?: string;
    smoothedTemp1?: string;
    smoothedTemp2?: string;
    smoothedHumidity1?: string;
    smoothedHumidity2?: string;
    ambientSensor1?: string;
    ambientSensor2?: string;
    irSensor1?: string;
    irSensor2?: string;
    slope1?: string;
    slope2?: string;
    finalGrapheneSensorData?: string;
    baselineGrapheneSensorData?: string;
    smoothedGrapheneSensorData?: string;
    tacValue?: string;
    setToZeroThreshold?: string;
    finalSuppressedData?: string;
    isTamper?: string;
    batteryLevel?: string;
    timeInterval?: string;
    createdAt?: string;
    updatedAt?: string;
    /** Preference */
    prefer?: 'return=representation' | 'return=minimal' | 'return=none';
    /** processed_sequence_items */
    processedSequenceItems?: ProcessedSequenceItems;
}

export interface ProcessedSequenceItemsPostRequestParams {
    /** Filtering Columns */
    select?: string;
    /** Preference */
    prefer?: 'return=representation' | 'return=minimal' | 'return=none' | 'resolution=ignore-duplicates' | 'resolution=merge-duplicates';
    /** processed_sequence_items */
    processedSequenceItems?: ProcessedSequenceItems;
}


@Injectable({
  providedIn: 'root'
})
export class ProcessedSequenceItemsService {

    protected basePath = 'http://0.0.0.0:3000';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (Array.isArray(basePath) && basePath.length > 0) {
                basePath = basePath[0];
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public processedSequenceItemsDelete(requestParameters: ProcessedSequenceItemsDeleteRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public processedSequenceItemsDelete(requestParameters: ProcessedSequenceItemsDeleteRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public processedSequenceItemsDelete(requestParameters: ProcessedSequenceItemsDeleteRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public processedSequenceItemsDelete(requestParameters: ProcessedSequenceItemsDeleteRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const id = requestParameters.id;
        const sequenceId = requestParameters.sequenceId;
        const rawSequenceItemId = requestParameters.rawSequenceItemId;
        const activityAt = requestParameters.activityAt;
        const smoothedVoltage = requestParameters.smoothedVoltage;
        const smoothedTemp1 = requestParameters.smoothedTemp1;
        const smoothedTemp2 = requestParameters.smoothedTemp2;
        const smoothedHumidity1 = requestParameters.smoothedHumidity1;
        const smoothedHumidity2 = requestParameters.smoothedHumidity2;
        const ambientSensor1 = requestParameters.ambientSensor1;
        const ambientSensor2 = requestParameters.ambientSensor2;
        const irSensor1 = requestParameters.irSensor1;
        const irSensor2 = requestParameters.irSensor2;
        const slope1 = requestParameters.slope1;
        const slope2 = requestParameters.slope2;
        const finalGrapheneSensorData = requestParameters.finalGrapheneSensorData;
        const baselineGrapheneSensorData = requestParameters.baselineGrapheneSensorData;
        const smoothedGrapheneSensorData = requestParameters.smoothedGrapheneSensorData;
        const tacValue = requestParameters.tacValue;
        const setToZeroThreshold = requestParameters.setToZeroThreshold;
        const finalSuppressedData = requestParameters.finalSuppressedData;
        const isTamper = requestParameters.isTamper;
        const batteryLevel = requestParameters.batteryLevel;
        const timeInterval = requestParameters.timeInterval;
        const createdAt = requestParameters.createdAt;
        const updatedAt = requestParameters.updatedAt;
        const prefer = requestParameters.prefer;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (id !== undefined && id !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>id, 'id');
        }
        if (sequenceId !== undefined && sequenceId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sequenceId, 'sequence_id');
        }
        if (rawSequenceItemId !== undefined && rawSequenceItemId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>rawSequenceItemId, 'raw_sequence_item_id');
        }
        if (activityAt !== undefined && activityAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>activityAt, 'activity_at');
        }
        if (smoothedVoltage !== undefined && smoothedVoltage !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>smoothedVoltage, 'smoothed_voltage');
        }
        if (smoothedTemp1 !== undefined && smoothedTemp1 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>smoothedTemp1, 'smoothed_temp_1');
        }
        if (smoothedTemp2 !== undefined && smoothedTemp2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>smoothedTemp2, 'smoothed_temp_2');
        }
        if (smoothedHumidity1 !== undefined && smoothedHumidity1 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>smoothedHumidity1, 'smoothed_humidity_1');
        }
        if (smoothedHumidity2 !== undefined && smoothedHumidity2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>smoothedHumidity2, 'smoothed_humidity_2');
        }
        if (ambientSensor1 !== undefined && ambientSensor1 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>ambientSensor1, 'ambient_sensor_1');
        }
        if (ambientSensor2 !== undefined && ambientSensor2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>ambientSensor2, 'ambient_sensor_2');
        }
        if (irSensor1 !== undefined && irSensor1 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>irSensor1, 'ir_sensor_1');
        }
        if (irSensor2 !== undefined && irSensor2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>irSensor2, 'ir_sensor_2');
        }
        if (slope1 !== undefined && slope1 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>slope1, 'slope_1');
        }
        if (slope2 !== undefined && slope2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>slope2, 'slope_2');
        }
        if (finalGrapheneSensorData !== undefined && finalGrapheneSensorData !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>finalGrapheneSensorData, 'final_graphene_sensor_data');
        }
        if (baselineGrapheneSensorData !== undefined && baselineGrapheneSensorData !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>baselineGrapheneSensorData, 'baseline_graphene_sensor_data');
        }
        if (smoothedGrapheneSensorData !== undefined && smoothedGrapheneSensorData !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>smoothedGrapheneSensorData, 'smoothed_graphene_sensor_data');
        }
        if (tacValue !== undefined && tacValue !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>tacValue, 'tac_value');
        }
        if (setToZeroThreshold !== undefined && setToZeroThreshold !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>setToZeroThreshold, 'set_to_zero_threshold');
        }
        if (finalSuppressedData !== undefined && finalSuppressedData !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>finalSuppressedData, 'final_suppressed_data');
        }
        if (isTamper !== undefined && isTamper !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>isTamper, 'is_tamper');
        }
        if (batteryLevel !== undefined && batteryLevel !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>batteryLevel, 'battery_level');
        }
        if (timeInterval !== undefined && timeInterval !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timeInterval, 'time_interval');
        }
        if (createdAt !== undefined && createdAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>createdAt, 'created_at');
        }
        if (updatedAt !== undefined && updatedAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>updatedAt, 'updated_at');
        }

        let localVarHeaders = this.defaultHeaders;
        if (prefer !== undefined && prefer !== null) {
            localVarHeaders = localVarHeaders.set('Prefer', String(prefer));
        }

        let localVarCredential: string | undefined;
        // authentication (JWT) required
        localVarCredential = this.configuration.lookupCredential('JWT');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/processed_sequence_items`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public processedSequenceItemsGet(requestParameters: ProcessedSequenceItemsGetRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/vnd.pgrst.object+json;nulls=stripped' | 'application/vnd.pgrst.object+json' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<Array<ProcessedSequenceItems>>;
    public processedSequenceItemsGet(requestParameters: ProcessedSequenceItemsGetRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/vnd.pgrst.object+json;nulls=stripped' | 'application/vnd.pgrst.object+json' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<ProcessedSequenceItems>>>;
    public processedSequenceItemsGet(requestParameters: ProcessedSequenceItemsGetRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/vnd.pgrst.object+json;nulls=stripped' | 'application/vnd.pgrst.object+json' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<ProcessedSequenceItems>>>;
    public processedSequenceItemsGet(requestParameters: ProcessedSequenceItemsGetRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/vnd.pgrst.object+json;nulls=stripped' | 'application/vnd.pgrst.object+json' | 'text/csv', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const id = requestParameters.id;
        const sequenceId = requestParameters.sequenceId;
        const rawSequenceItemId = requestParameters.rawSequenceItemId;
        const activityAt = requestParameters.activityAt;
        const smoothedVoltage = requestParameters.smoothedVoltage;
        const smoothedTemp1 = requestParameters.smoothedTemp1;
        const smoothedTemp2 = requestParameters.smoothedTemp2;
        const smoothedHumidity1 = requestParameters.smoothedHumidity1;
        const smoothedHumidity2 = requestParameters.smoothedHumidity2;
        const ambientSensor1 = requestParameters.ambientSensor1;
        const ambientSensor2 = requestParameters.ambientSensor2;
        const irSensor1 = requestParameters.irSensor1;
        const irSensor2 = requestParameters.irSensor2;
        const slope1 = requestParameters.slope1;
        const slope2 = requestParameters.slope2;
        const finalGrapheneSensorData = requestParameters.finalGrapheneSensorData;
        const baselineGrapheneSensorData = requestParameters.baselineGrapheneSensorData;
        const smoothedGrapheneSensorData = requestParameters.smoothedGrapheneSensorData;
        const tacValue = requestParameters.tacValue;
        const setToZeroThreshold = requestParameters.setToZeroThreshold;
        const finalSuppressedData = requestParameters.finalSuppressedData;
        const isTamper = requestParameters.isTamper;
        const batteryLevel = requestParameters.batteryLevel;
        const timeInterval = requestParameters.timeInterval;
        const createdAt = requestParameters.createdAt;
        const updatedAt = requestParameters.updatedAt;
        const select = requestParameters.select;
        const order = requestParameters.order;
        const range = requestParameters.range;
        const rangeUnit = requestParameters.rangeUnit;
        const offset = requestParameters.offset;
        const limit = requestParameters.limit;
        const prefer = requestParameters.prefer;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (id !== undefined && id !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>id, 'id');
        }
        if (sequenceId !== undefined && sequenceId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sequenceId, 'sequence_id');
        }
        if (rawSequenceItemId !== undefined && rawSequenceItemId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>rawSequenceItemId, 'raw_sequence_item_id');
        }
        if (activityAt !== undefined && activityAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>activityAt, 'activity_at');
        }
        if (smoothedVoltage !== undefined && smoothedVoltage !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>smoothedVoltage, 'smoothed_voltage');
        }
        if (smoothedTemp1 !== undefined && smoothedTemp1 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>smoothedTemp1, 'smoothed_temp_1');
        }
        if (smoothedTemp2 !== undefined && smoothedTemp2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>smoothedTemp2, 'smoothed_temp_2');
        }
        if (smoothedHumidity1 !== undefined && smoothedHumidity1 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>smoothedHumidity1, 'smoothed_humidity_1');
        }
        if (smoothedHumidity2 !== undefined && smoothedHumidity2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>smoothedHumidity2, 'smoothed_humidity_2');
        }
        if (ambientSensor1 !== undefined && ambientSensor1 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>ambientSensor1, 'ambient_sensor_1');
        }
        if (ambientSensor2 !== undefined && ambientSensor2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>ambientSensor2, 'ambient_sensor_2');
        }
        if (irSensor1 !== undefined && irSensor1 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>irSensor1, 'ir_sensor_1');
        }
        if (irSensor2 !== undefined && irSensor2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>irSensor2, 'ir_sensor_2');
        }
        if (slope1 !== undefined && slope1 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>slope1, 'slope_1');
        }
        if (slope2 !== undefined && slope2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>slope2, 'slope_2');
        }
        if (finalGrapheneSensorData !== undefined && finalGrapheneSensorData !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>finalGrapheneSensorData, 'final_graphene_sensor_data');
        }
        if (baselineGrapheneSensorData !== undefined && baselineGrapheneSensorData !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>baselineGrapheneSensorData, 'baseline_graphene_sensor_data');
        }
        if (smoothedGrapheneSensorData !== undefined && smoothedGrapheneSensorData !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>smoothedGrapheneSensorData, 'smoothed_graphene_sensor_data');
        }
        if (tacValue !== undefined && tacValue !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>tacValue, 'tac_value');
        }
        if (setToZeroThreshold !== undefined && setToZeroThreshold !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>setToZeroThreshold, 'set_to_zero_threshold');
        }
        if (finalSuppressedData !== undefined && finalSuppressedData !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>finalSuppressedData, 'final_suppressed_data');
        }
        if (isTamper !== undefined && isTamper !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>isTamper, 'is_tamper');
        }
        if (batteryLevel !== undefined && batteryLevel !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>batteryLevel, 'battery_level');
        }
        if (timeInterval !== undefined && timeInterval !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timeInterval, 'time_interval');
        }
        if (createdAt !== undefined && createdAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>createdAt, 'created_at');
        }
        if (updatedAt !== undefined && updatedAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>updatedAt, 'updated_at');
        }
        if (select !== undefined && select !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>select, 'select');
        }
        if (order !== undefined && order !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>order, 'order');
        }
        if (offset !== undefined && offset !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>offset, 'offset');
        }
        if (limit !== undefined && limit !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>limit, 'limit');
        }

        let localVarHeaders = this.defaultHeaders;
        if (range !== undefined && range !== null) {
            localVarHeaders = localVarHeaders.set('Range', String(range));
        }
        if (rangeUnit !== undefined && rangeUnit !== null) {
            localVarHeaders = localVarHeaders.set('Range-Unit', String(rangeUnit));
        }
        if (prefer !== undefined && prefer !== null) {
            localVarHeaders = localVarHeaders.set('Prefer', String(prefer));
        }

        let localVarCredential: string | undefined;
        // authentication (JWT) required
        localVarCredential = this.configuration.lookupCredential('JWT');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/vnd.pgrst.object+json;nulls=stripped',
                'application/vnd.pgrst.object+json',
                'text/csv'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/processed_sequence_items`;
        return this.httpClient.request<Array<ProcessedSequenceItems>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public processedSequenceItemsPatch(requestParameters: ProcessedSequenceItemsPatchRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public processedSequenceItemsPatch(requestParameters: ProcessedSequenceItemsPatchRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public processedSequenceItemsPatch(requestParameters: ProcessedSequenceItemsPatchRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public processedSequenceItemsPatch(requestParameters: ProcessedSequenceItemsPatchRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const id = requestParameters.id;
        const sequenceId = requestParameters.sequenceId;
        const rawSequenceItemId = requestParameters.rawSequenceItemId;
        const activityAt = requestParameters.activityAt;
        const smoothedVoltage = requestParameters.smoothedVoltage;
        const smoothedTemp1 = requestParameters.smoothedTemp1;
        const smoothedTemp2 = requestParameters.smoothedTemp2;
        const smoothedHumidity1 = requestParameters.smoothedHumidity1;
        const smoothedHumidity2 = requestParameters.smoothedHumidity2;
        const ambientSensor1 = requestParameters.ambientSensor1;
        const ambientSensor2 = requestParameters.ambientSensor2;
        const irSensor1 = requestParameters.irSensor1;
        const irSensor2 = requestParameters.irSensor2;
        const slope1 = requestParameters.slope1;
        const slope2 = requestParameters.slope2;
        const finalGrapheneSensorData = requestParameters.finalGrapheneSensorData;
        const baselineGrapheneSensorData = requestParameters.baselineGrapheneSensorData;
        const smoothedGrapheneSensorData = requestParameters.smoothedGrapheneSensorData;
        const tacValue = requestParameters.tacValue;
        const setToZeroThreshold = requestParameters.setToZeroThreshold;
        const finalSuppressedData = requestParameters.finalSuppressedData;
        const isTamper = requestParameters.isTamper;
        const batteryLevel = requestParameters.batteryLevel;
        const timeInterval = requestParameters.timeInterval;
        const createdAt = requestParameters.createdAt;
        const updatedAt = requestParameters.updatedAt;
        const prefer = requestParameters.prefer;
        const processedSequenceItems = requestParameters.processedSequenceItems;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (id !== undefined && id !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>id, 'id');
        }
        if (sequenceId !== undefined && sequenceId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>sequenceId, 'sequence_id');
        }
        if (rawSequenceItemId !== undefined && rawSequenceItemId !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>rawSequenceItemId, 'raw_sequence_item_id');
        }
        if (activityAt !== undefined && activityAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>activityAt, 'activity_at');
        }
        if (smoothedVoltage !== undefined && smoothedVoltage !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>smoothedVoltage, 'smoothed_voltage');
        }
        if (smoothedTemp1 !== undefined && smoothedTemp1 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>smoothedTemp1, 'smoothed_temp_1');
        }
        if (smoothedTemp2 !== undefined && smoothedTemp2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>smoothedTemp2, 'smoothed_temp_2');
        }
        if (smoothedHumidity1 !== undefined && smoothedHumidity1 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>smoothedHumidity1, 'smoothed_humidity_1');
        }
        if (smoothedHumidity2 !== undefined && smoothedHumidity2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>smoothedHumidity2, 'smoothed_humidity_2');
        }
        if (ambientSensor1 !== undefined && ambientSensor1 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>ambientSensor1, 'ambient_sensor_1');
        }
        if (ambientSensor2 !== undefined && ambientSensor2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>ambientSensor2, 'ambient_sensor_2');
        }
        if (irSensor1 !== undefined && irSensor1 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>irSensor1, 'ir_sensor_1');
        }
        if (irSensor2 !== undefined && irSensor2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>irSensor2, 'ir_sensor_2');
        }
        if (slope1 !== undefined && slope1 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>slope1, 'slope_1');
        }
        if (slope2 !== undefined && slope2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>slope2, 'slope_2');
        }
        if (finalGrapheneSensorData !== undefined && finalGrapheneSensorData !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>finalGrapheneSensorData, 'final_graphene_sensor_data');
        }
        if (baselineGrapheneSensorData !== undefined && baselineGrapheneSensorData !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>baselineGrapheneSensorData, 'baseline_graphene_sensor_data');
        }
        if (smoothedGrapheneSensorData !== undefined && smoothedGrapheneSensorData !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>smoothedGrapheneSensorData, 'smoothed_graphene_sensor_data');
        }
        if (tacValue !== undefined && tacValue !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>tacValue, 'tac_value');
        }
        if (setToZeroThreshold !== undefined && setToZeroThreshold !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>setToZeroThreshold, 'set_to_zero_threshold');
        }
        if (finalSuppressedData !== undefined && finalSuppressedData !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>finalSuppressedData, 'final_suppressed_data');
        }
        if (isTamper !== undefined && isTamper !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>isTamper, 'is_tamper');
        }
        if (batteryLevel !== undefined && batteryLevel !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>batteryLevel, 'battery_level');
        }
        if (timeInterval !== undefined && timeInterval !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>timeInterval, 'time_interval');
        }
        if (createdAt !== undefined && createdAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>createdAt, 'created_at');
        }
        if (updatedAt !== undefined && updatedAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>updatedAt, 'updated_at');
        }

        let localVarHeaders = this.defaultHeaders;
        if (prefer !== undefined && prefer !== null) {
            localVarHeaders = localVarHeaders.set('Prefer', String(prefer));
        }

        let localVarCredential: string | undefined;
        // authentication (JWT) required
        localVarCredential = this.configuration.lookupCredential('JWT');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/vnd.pgrst.object+json;nulls=stripped',
            'application/vnd.pgrst.object+json',
            'text/csv'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/processed_sequence_items`;
        return this.httpClient.request<any>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: processedSequenceItems,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public processedSequenceItemsPost(requestParameters: ProcessedSequenceItemsPostRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public processedSequenceItemsPost(requestParameters: ProcessedSequenceItemsPostRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public processedSequenceItemsPost(requestParameters: ProcessedSequenceItemsPostRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public processedSequenceItemsPost(requestParameters: ProcessedSequenceItemsPostRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const select = requestParameters.select;
        const prefer = requestParameters.prefer;
        const processedSequenceItems = requestParameters.processedSequenceItems;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (select !== undefined && select !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>select, 'select');
        }

        let localVarHeaders = this.defaultHeaders;
        if (prefer !== undefined && prefer !== null) {
            localVarHeaders = localVarHeaders.set('Prefer', String(prefer));
        }

        let localVarCredential: string | undefined;
        // authentication (JWT) required
        localVarCredential = this.configuration.lookupCredential('JWT');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }

        let localVarTransferCache: boolean | undefined = options && options.transferCache;
        if (localVarTransferCache === undefined) {
            localVarTransferCache = true;
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/vnd.pgrst.object+json;nulls=stripped',
            'application/vnd.pgrst.object+json',
            'text/csv'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/processed_sequence_items`;
        return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: processedSequenceItems,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
